module.exports = __webpack_public_path__ + "img/shouqian.24902ec9.png";